<template>
    <div id="recruiter_new_candidates" class="flex_content" v-if='dataLoaded'>

        <div id="context_bar">
            <TopbarGoPositionsList/>
            <TopbarTabs />
            <TopbarSaveButton />
        </div>

        <transition :name="stepAnim">
            <component :is="currentStepComponent" :is-new="false" ></component>
        </transition>
    </div>

</template>

<script>
import TopbarGoPositionsList from "../components/topbar/topbarGoPositionsList"
import TopbarTabs from "../components/topbar/topbarTabs"
import TopbarSaveButton from "../components/topbar/topbarSaveButton"

import FormStep1 from "../components/form/formStep1"
import FormStep2 from "../components/form/formStep2"
import FormStep3 from "../components/form/formStep3"
import FormStep4 from "../components/form/formStep4"
import FormStep5 from "../components/form/formStep5"


export default {
    name: 'PositionEdit',
    components: {
        TopbarGoPositionsList,
        TopbarTabs,
        TopbarSaveButton,
        FormStep1,
        FormStep2,
        FormStep3,
        FormStep4,
        FormStep5
    },
    beforeCreate() {
        this.$store.dispatch('PositionStore/initEdit', this.$route.params.id).then( () => {this.dataLoaded = true})
        this.$store.dispatch('RefStore/indexCats', "saven")
        this.$store.dispatch('RefStore/indexCats', "custom")
        this.$store.dispatch('RefStore/indexRefs', "saven")
        this.$store.dispatch('RefStore/indexRefs', "custom")
        this.$store.dispatch('RefStore/indexCats', "custom_company")
        this.$store.dispatch('RefStore/indexRefs', "custom_company")
    },
    data(){
        return {
            stepAnim: "tab-slide-right",
            dataLoaded: false
        }
    },
    computed: {
        currentStepComponent(){
            return this.$store.state.PositionStore.formStepsName[this.$store.state.PositionStore.formCurrentStep]
        }
    },
    watch: {
        currentStepComponent: function(newVal, oldVal){
            const newIndex = this.$store.state.PositionStore.formStepsName.indexOf(newVal)
            const oldIndex = this.$store.state.PositionStore.formStepsName.indexOf(oldVal)
            if(newIndex > oldIndex){
                this.stepAnim = "tab-slide-right"
            }else{
                this.stepAnim = "tab-slide-left"
            }


        }
    },
    beforeDestroy(){
        this.$store.dispatch('PositionStore/initNew')
    }
}
</script>

<style lang="scss">
    .steps_nav{
        flex: 1;
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;
    }
</style>

